import { useEffect, useState } from 'react';
import { getTravelBallAvailability } from '../services/travelBallFamily';

/** Where the anonymous availability read stands: still out, open, or closed (which any failure is). */
export type TravelBallAvailabilityStatus = 'checking' | 'open' | 'closed';

/**
 * Whether travel ball is open to the public, for signed-out pages that offer travel ball signup. Read
 * once per mount from `GET /api/public/travel-ball/availability` (never cached), and `closed` on any
 * failure, so a signup the API would refuse is never offered.
 */
export const useTravelBallAvailabilityStatus = (): TravelBallAvailabilityStatus => {
  const [status, setStatus] = useState<TravelBallAvailabilityStatus>('checking');

  useEffect(() => {
    let cancelled = false;
    void getTravelBallAvailability().then((value) => {
      if (!cancelled) setStatus(value ? 'open' : 'closed');
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
};

/**
 * `true` only once the availability read answers yes: `false` while it is out and on any failure, so a
 * link to a signup the API would refuse is never shown.
 */
export const useTravelBallAvailability = (): boolean => useTravelBallAvailabilityStatus() === 'open';
